const Quotes = () => import("Modules/sales/quotes/views/Quotes");
const QuotesForm = () => import("Modules/sales/quotes/views/QuotesForm");

export default {
    children: [
        {
            path: "sales/quotes",
            name: "quotes",
            component: Quotes,
            meta: {
                requiresAuth: true,
                title: "lang.quotes",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["quotes.read"],
            },
        },
        {
            path: "sales/quote/:id?",
            name: "quote",
            component: QuotesForm,
            meta: {
                requiresAuth: true,
                title: "lang.quotes",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["quotes.read"],
            },
        },
    ],
};
